<template>
  <div class="container">
    <div v-for="sideMenuItem in sideMenuItems" :key="sideMenuItem.link">
      <side-menu-link
        v-if="!sideMenuItem.canExpand && !sideMenuItem.canEdit"
        :expand="expand"
        :novelId="novelId"
        :link="sideMenuItem.link"
        :text="sideMenuItem.text"
        :icon="sideMenuItem.icon"
        :active-routes="sideMenuItem.activeRoutes"
      />
      <side-menu-expand-link
        v-else-if="sideMenuItem.canExpand && !sideMenuItem.canEdit"
        :expand="expand"
        :novelId="novelId"
        :link="sideMenuItem.link"
        :text="sideMenuItem.text"
        :icon="sideMenuItem.icon"
        :children="sideMenuItem.children"
      />
      <side-menu-expand-editable-link
        v-else
        :expand="expand"
        :novelId="novelId"
        :link="sideMenuItem.link"
        :text="sideMenuItem.text"
        :icon="sideMenuItem.icon"
      />
    </div>
  </div>
</template>

<script lang="ts">
/* eslint-disable global-require */
import Vue from "vue";
import SideMenuLink from "@/components/atoms/SideMenuLink.vue";
import SideMenuExpandEditableLink from "@/components/atoms/SideMenuExpandEditableLink.vue";
import SideMenuExpandLink from "@/components/atoms/SideMenuExpandLink.vue";

interface Computed {
  sideMenuItems: SideMenuItem[];
}

interface Props {
  novelId: string;
  expand: boolean;
}

type SideMenuItem = {
  text: string;
  icon?: string;
  link: string;
  canExpand: boolean;
  canEdit: boolean;
  activeRoutes?: string[];
  children?: SideMenuItem[];
};

export default Vue.extend<unknown, unknown, Computed, Props>({
  components: { SideMenuLink, SideMenuExpandLink, SideMenuExpandEditableLink },
  props: {
    novelId: String,
    expand: Boolean,
  },
  computed: {
    sideMenuItems() {
      return [
        {
          text: this.$t("sideMenuLinkList.theme") as string,
          icon: require("@/assets/img/menu-icon/theme.png"),
          link: "theme",
          canExpand: false,
          canEdit: false,
        },
        {
          text: this.$t("sideMenuLinkList.structure") as string,
          icon: require("@/assets/img/menu-icon/structure.svg"),
          link: "plot",
          canExpand: true,
          canEdit: false,
          children: [
            {
              text: this.$t("sideMenuLinkList.plot") as string,
              icon: require("@/assets/icons/figma/FolderTree.svg"),
              link: "plot",
              canExpand: false,
              canEdit: false,
            },
            {
              text: this.$t("sideMenuLinkList.plotMaker") as string,
              icon: require("@/assets/img/menu-icon/plot-maker.png"),
              link: "plotMaker",
              canExpand: false,
              canEdit: false,
            },
            {
              text: this.$t("sideMenuLinkList.timeline") as string,
              icon: require("@/assets/img/menu-icon/table_chart.svg"),
              link: "timeline",
              canExpand: true,
              canEdit: false,
            },
          ],
        },
        {
          text: this.$t("sideMenuLinkList.writing") as string,
          icon: require("@/assets/img/menu-icon/edit.png"),
          link: "editor",
          canExpand: false,
          canEdit: false,
        },
        {
          text: this.$t("sideMenuLinkList.materials") as string,
          icon: require("@/assets/img/menu-icon/materials.png"),
          link: "materials",
          canExpand: true,
          canEdit: true,
        },
        {
          text: this.$t("sideMenuLinkList.memo") as string,
          icon: require("@/assets/img/icon/file-document-edit-outline.png"),
          link: "memoInNovel",
          canExpand: false,
          canEdit: false,
        },
        {
          text: this.$t("sideMenuLinkList.proofreading") as string,
          icon: require("@/assets/icons/figma/Check.svg"),
          link: "proofreadingSelectType",
          canExpand: false,
          canEdit: false,
          activeRoutes: [
            "proofreadingSelectManuscript",
            "proofreadingReviseManuscript",
            "proofreadingPreviewPlan",
            "proofreadingSelectChecks",
            "proofreadingWaiting",
          ],
        },
      ];
    },
  },
});
</script>

<style lang="scss" scoped>
.container {
  margin-top: 1rem;
}
</style>
